<script setup>
import { component as VueNumber } from '@coders-tm/vue-number-format'

defineProps({
    modelValue: String,
});

const config = {
    decimal: '.',
    separator: "'",
    prefix: 'CHF ',
    precision: 0,
    masked: true,
}

defineEmits(['update:modelValue']);
</script>

<template>
    <vue-number :model-value="modelValue"
                class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm"
                @input="$emit('update:modelValue', $event.target.value)" v-bind="config"></vue-number>
</template>
